import { FC } from "react";
import classNames from "classnames";
import { ScanPageRightCustomProps, ScanPageRightItemEnum, } from "../../interface";
/** 自定义右侧内容 */
const Custom: FC<ScanPageRightCustomProps> = props => {
  const { className, style, children, } = props;
  const classes = classNames('body-right-custom', className);
  return (
    <div className={classes} style={style}>{children}</div>
  );
};

Custom.displayName = ScanPageRightItemEnum.RightCustom;

export default Custom;